import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserPushNotificationDeniedToast } from '../../api/hooks/push-notification.hooks';
import { PageHeader } from '../../components/header/page.header';
import { NotificationList } from '../../components/notifications/notification-list';

interface NotificationsPageProps {
  id: string;
}

const NotificationsPage = (_props: NotificationsPageProps): ReactElement => {
  const { i18n } = useTranslation();
  useUserPushNotificationDeniedToast();

  return (
    <IonPage>
      <PageHeader title={i18n.t('common:notifications')} />
      <IonContent>
        <NotificationList />
      </IonContent>
    </IonPage>
  );
};

export { NotificationsPage };
